<script>
export default {
  name: 'ModalCloseButton',
  methods: {
    handleCloseModal() {
      this.$store.commit('Predictor/SET_MODAL_STATUS', { showModal: false });
    },
  },
};
</script>

<template>
  <button class="modal-close-button" @click.prevent="handleCloseModal"></button>
</template>
